import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Velocity is equity",
    quote:
      "Every week your file sits in bank underwriting, margin evaporates. Speed is not a convenience — it is a line item.",
  },
  {
    num: "02",
    title: "Collateral is a prison",
    quote:
      "The moment you pledge your building, your trucks, your home — you stopped owning a business and started renting one back from a bank.",
  },
  {
    num: "03",
    title: "The syndicate works for you",
    quote:
      "One lender quotes you. Thirty lenders compete for you. The merchant who runs an auction never takes the first offer.",
  },
];

export default function NumberedManifesto() {
  return (
    <section id="manifesto" className="py-24 sm:py-32" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="eyebrow mb-16"
        >
          The Forward Exspansion doctrine
        </motion.p>
        <div className="border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-12 sm:py-16 border-b border-white/10"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="md:col-span-2 font-display text-6xl sm:text-7xl font-extralight text-outline group-hover:text-amber-400 group-hover:[-webkit-text-stroke:0px] transition-all duration-700">
                {c.num}
              </span>
              <h3 className="md:col-span-4 font-display text-2xl sm:text-3xl font-normal tracking-tight text-zinc-100 self-start md:pt-3">
                {c.title}
              </h3>
              <p className="md:col-span-6 font-editorial italic text-lg sm:text-xl leading-relaxed text-zinc-400 md:pt-3">
                “{c.quote}”
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
